import { Dispatch } from "../../config/controller";
import { Atendimento, Paciente } from "../../config/data.types";
import { Model, StateProps } from "../../config/model";
import { listDataText } from "../../services/utils";


export type { Paciente } from "../../config/data.types";

export interface FilterPaciente {
    dtIni: string,
    dtFim: string,
    show_data_label: string
    opt_data_select?: any
}


export interface PacienteState extends StateProps<Paciente> {
    filtro: FilterPaciente
    rows_paciente_atendimento:Paciente[]
}

export interface PacienteActions extends Dispatch<Paciente> {
    setFiltro: (filtro: FilterPaciente) => any
    readPacientesByAtendimento:(row:Atendimento)=>any
}

const model = new Model<Paciente, PacienteState>("paciente");

const listDataOpt = listDataText();

export const initialValuePaciente: Paciente = {
    ...model.getInitialValue(),
    type: "paciente",
    nome: "",
    atendimento: {
        _id: "",
        sala_desc: "",
        medico: {
            _id: "",
            nome: ""
        }
    },
    dt_hr_chamada: "",
    dt_hr_chegada: "",
    dt_hr_saida: "",
    situacao: "AGUARDANDO",
    chamando: false
}

export const initialValuePacienteState: PacienteState = {
    ...model.getInititalValueState(),
    row: initialValuePaciente,
    filtro: {
        dtIni: listDataOpt[0].value.dtIni,
        dtFim: listDataOpt[0].value.dtFim,
        show_data_label: "Hoje",
        opt_data_select: listDataOpt[0],
    },
    rows_paciente_atendimento:[]
}


